import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import './InspireSlider.scss';
import SliderDots from '../../../components/SliderDots/SliderDots';

const sliderData = [
  {
    title: 'Системный подход и забота о здоровье на одной платформе',
    description:
      'Персональный AI ассистент для поддержки здорового образа жизни',
  },
  // {
  //   title: 'Стань лучшей версией себя',
  //   description:
  //     'Управляй здоровьем без строгостей: наш AI-наставник подберёт еду, воду и тренировки под тебя!',
  // },
  // {
  //   title: 'Стань лучшей версией себя',
  //   description:
  //     'Управляй здоровьем без строгостей: наш AI-наставник подберёт еду, воду и тренировки под тебя!',
  // },
  // {
  //   title: 'Стань лучшей версией себя',
  //   description:
  //     'Управляй здоровьем без строгостей: наш AI-наставник подберёт еду, воду и тренировки под тебя!',
  // },
];

const InspireSlider = () => {
  const [index, setIndex] = useState(0);

  return (
    <div className="inspire-slider-wrapper">
      <Swiper
        speed={600}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="inspire-slider"
        onRealIndexChange={(swiper) => setIndex(swiper.realIndex)}
      >
        {sliderData.map(({ title, description }) => {
          return (
            <SwiperSlide className="inspiration-slide">
              <h3 className="title">{title}</h3>
              <p className="description">{description}</p>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <SliderDots count={sliderData.length} activeIndex={index} />
    </div>
  );
};

export default InspireSlider;
